import React from 'react';

const Hero = () => {
  return (
    <section id="inicio" className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-left">
            <img 
              src="/logos/hero_logo.PNG" 
              alt="Fiesta del Tendero" 
              className="hero-logo"
            />
          </div>
          <div className="hero-right">
            <h1>Fiesta del Tendero</h1>
            <p>La fiesta que une al comercio en Magangué</p>
            <p className="hero-description">
              Un evento único que celebra el espíritu emprendedor y comercial de nuestra región. 
              Únete a nosotros en esta gran celebración donde el comercio local toma protagonismo.
            </p>
            <div className="hero-buttons">
              <a href="https://acsware.co/lafiestadeltenderomagangue/" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                Regístrate Ahora
              </a>
              <a href="#evento" className="btn btn-outline">
                Conoce Más
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;